"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Avatar = require("../../components/Avatar/Avatar.styles");
var _ButtonIcon = require("../../components/ButtonIcon/ButtonIcon.styles");
var _Icon = require("../../components/Icon/Icon.styles");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var elevationCSS = function elevationCSS(props) {
  var chipElevation = props.chipElevation;
  if (!chipElevation) {
    return '';
  }
  return (0, _styledToken.default)({
    boxShadow: 'Chip.boxShadow.default'
  }, function (_ref) {
    var boxShadow = _ref.boxShadow;
    return (0, _styledComponents.css)(["&:not(:focus-visible){box-shadow:", ";}"], boxShadow);
  })(props);
};

/** @class ChipMixin */
/** @method */
var ChipMixin = function ChipMixin(props) {
  return (0, _styledToken.default)({
    avatarSize: "Chip.avatarSize",
    borderRadius: "Chip.borderRadius",
    fontType: "Chip.fontType",
    horizontalSpacing: "Chip.horizontalSpacing",
    iconSize: "Chip.iconSize",
    targetSize: "Chip.targetSize"
  }, function (_ref2) {
    var avatarSize = _ref2.avatarSize,
      borderRadius = _ref2.borderRadius,
      fontType = _ref2.fontType,
      horizontalSpacing = _ref2.horizontalSpacing,
      iconSize = _ref2.iconSize,
      targetSize = _ref2.targetSize;
    return (0, _styledComponents.css)(["border-radius:", ";padding-right:", "px;padding-left:", "px;min-width:0;&:after{height:", "px;margin-top:-", "px;}", "{flex:0 0 auto;width:", "px;margin-right:", ";}", ",& > ", "{margin-right:", ";width:", "px;}", " ", " ", ""], borderRadius, horizontalSpacing, horizontalSpacing, targetSize, targetSize / 2, _Avatar.StyledAvatar, avatarSize, (0, _spaceMixin.spaceMixin)('xs'), _ButtonIcon.StyledButtonIcon, _Icon.StyledIcon, (0, _spaceMixin.spaceMixin)('xs'), iconSize, (0, _spacingMixin.spacingMixin)(props), (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), elevationCSS(props));
  })(props);
};
exports.ChipMixin = ChipMixin;